var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemplate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#F2F2F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 17H14V19H20V17ZM22.7812 12.2812L19.7188 9.21875C19.5625 9.09375 19.375 9 19.1875 9H19V13H23V12.8125C23 12.625 22.9062 12.4375 22.7812 12.2812ZM18 13.25V9H11.75C11.3125 9 11 9.34375 11 9.75V24.25C11 24.6875 11.3125 25 11.75 25H22.25C22.6562 25 23 24.6875 23 24.25V14H18.75C18.3125 14 18 13.6875 18 13.25ZM13 11.25C13 11.125 13.0938 11 13.25 11H15.75C15.875 11 16 11.125 16 11.25V11.75C16 11.9062 15.875 12 15.75 12H13.25C13.0938 12 13 11.9062 13 11.75V11.25ZM13 13.25C13 13.125 13.0938 13 13.25 13H15.75C15.875 13 16 13.125 16 13.25V13.75C16 13.9062 15.875 14 15.75 14H13.25C13.0938 14 13 13.9062 13 13.75V13.25ZM21 22.75C21 22.9062 20.875 23 20.75 23H18.25C18.0938 23 18 22.9062 18 22.75V22.25C18 22.125 18.0938 22 18.25 22H20.75C20.875 22 21 22.125 21 22.25V22.75ZM21 16.5V19.5C21 19.7812 20.75 20 20.5 20H13.5C13.2188 20 13 19.7812 13 19.5V16.5C13 16.25 13.2188 16 13.5 16H20.5C20.75 16 21 16.25 21 16.5Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.2688d1ad.svg";
export { ForwardRef as ReactComponent };